export function PostData(type, userData) {
  // Use environment variable for API URL
  // Falls back to localhost if not defined
  let BaseUrl =
    process.env.REACT_APP_API_BASE_URL || "http://localhost/api/index.php";

  console.log(`Using API endpoint: ${BaseUrl}?tp=${type}`);

  return new Promise((resolve, reject) => {
    // Set up fetch options
    const fetchOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // For CORS requests
      mode: "cors",
      // In production, we don't need credentials for this API
      // This is often the cause of CORS issues
      credentials: "same-origin",
      body: JSON.stringify(userData),
    };

    fetch(BaseUrl + "?tp=" + type, fetchOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error(`API request error for ${type}:`, error);
        reject(error);
      });
  });
}
